import React, { Ref } from "react";

export interface Props {
	className?: string;
	children: React.ReactNode;
	index: number;
	onClick: () => void;
	active: boolean;
	selected: boolean;
	forwardedRef: Ref<HTMLDivElement>;
	name: string;
	initFocus: boolean;
	onMouseDown?: () => void;
	focus: boolean;
}

export default function ElementsListItem({
	className,
	children,
	onClick,
	index,
	active,
	selected,
	forwardedRef,
	name,
	initFocus,
	onMouseDown,
	focus,
}: Props) {
	return (
		<div
			ref={active ? forwardedRef : null}
			role="option"
			aria-selected={selected}
			className={`list-group-item ${name}-list__item ${
				className ? className : ""
			} ${active ? "selected" : ""} ${
				active && initFocus && focus ? "active" : ""
			}`}
			onMouseDown={onMouseDown}
			onClick={onClick}
			id={`${name}-list__item__${index}`}>
			{children}
		</div>
	);
}
